import { StyleSheet } from 'react-native';

export const globalStyle = StyleSheet.create({
  flex1: { flex: 1 },
  vhcenter: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  vharound: {
    justifyContent: 'space-around',
    alignItems: 'center',
  },
});
